import {orderBy} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import MuiSelect from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import {pickAttributes} from '../../../helpers/utils'

const useStyles = makeStyles(selectStyles)

export default function Select (props) {

  const classes = useStyles()

  const {context} = props
  const {translate, quizDirectories} = context

  const controlAttributes = pickAttributes(props, 'control')
  const selectAttributes = pickAttributes(props, 'select')

  const labelId = `${props.id}-label`

  const options = [{id: '', name: translate('none')}].concat(orderBy(Object.values(quizDirectories), ['name','id']))

  return (
    <Box className={clsx(classes.root, props.className)}>
      <Box className={clsx(classes.label, "label")}>{props.caption}:</Box>
      <Box className={clsx(classes.input, "input")}>
        <FormControl
          {...controlAttributes}
          className={classes.control}
        >
          <MuiSelect
            labelId={labelId}
            id={props.id}
            {...selectAttributes}
            className={clsx(classes.select, "select")}
          >
            {options.map((option, key) => (
              <MenuItem value={option.id} key={key}>{option.name}</MenuItem>)
            )}
          </MuiSelect>
        </FormControl>
      </Box>
    </Box>
  )
}


function selectStyles(theme) {
  return {
    root: {
      '& .MuiInput-underline:before': {
        content: 'none',
        border: 'none'
      },
      '& .MuiSelect-select': {
        border: 'solid 1px #aab7bf',
        borderRadius: 4,
        padding: 5,
        paddingRight: 24
      },
    },
    control: {
      margin: 0,
      flexGrow: 1
    }
  }
}
